import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  className = '',
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-game-coral text-white shadow-game-coral/30',
    secondary: 'bg-white text-game-dark border-2 border-gray-100',
    accent: 'bg-game-yellow text-game-dark shadow-game-yellow/30',
    ghost: 'bg-transparent text-game-dark hover:bg-gray-100'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg font-bold'
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 17
  }} className={`
        relative inline-flex items-center justify-center gap-2
        rounded-full font-fredoka font-semibold tracking-wide
        shadow-lg transition-colors
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `} {...props} data-id="element-164">
      {icon && <span className="text-current" data-id="element-165">{icon}</span>}
      {children}
    </motion.button>;
}